import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=92635de0&scoped=true"
import script from "./ChangelogModal.vue?vue&type=script&lang=js"
export * from "./ChangelogModal.vue?vue&type=script&lang=js"
import style0 from "./ChangelogModal.vue?vue&type=style&index=0&id=92635de0&prod&scoped=true&lang=css"
import style1 from "./ChangelogModal.vue?vue&type=style&index=1&id=92635de0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92635de0",
  null
  
)

export default component.exports